
interface TDSYNNEXLogoProps {
    white?: boolean;
}

export const TDSYNNEXLogo = ({ white }: TDSYNNEXLogoProps) => {
    const logoUrl = white 
        ? "/assets/images/TD_SYNNEX_Logo_WHT.png" 
        : "/assets/images/TD_SYNNEX_Logo_CLR_RGB.png";

    return (
        <img 
            src={logoUrl} 
            alt="TD SYNNEX Logo" 
            style={{ width: '150px', height: 'auto' }} 
        />
    );
};
